import { useBoundingBox } from "./element-hooks";
import { ElementDto } from "@repo/api/overlays";
import { useElementMotionStore } from "@/lib/stores/element-motion-store/element-motion-store";
import { useCurrentScale } from "remotion";
import { BoundingBox } from "@/lib/stores/element-motion-store/element-motion-state";
import { useMemo } from "react";

type Props = {
  element: ElementDto;
  selectionBoundingBox: BoundingBox | null;
};

export default function ElementOutline({
  element,
  selectionBoundingBox,
}: Props) {
  const scale = useCurrentScale() || 1;
  const outlineWidth = Math.round(2 / scale);

  const { left, top, right, bottom } = useBoundingBox(element.externalId);
  const isMultipleSelected = useElementMotionStore((state) => {
    return (
      state.selectedElementIds.size > 1 &&
      state.selectedElementIds.has(element.externalId)
    );
  });

  const isSameAsSelectionBoundingBox = useMemo(() => {
    return (
      selectionBoundingBox &&
      left === selectionBoundingBox.left &&
      top === selectionBoundingBox.top &&
      right === selectionBoundingBox.right &&
      bottom === selectionBoundingBox.bottom
    );
  }, [selectionBoundingBox, left, top, right, bottom]);

  if (
    !isMultipleSelected ||
    isSameAsSelectionBoundingBox ||
    left === undefined ||
    top === undefined ||
    right === undefined ||
    bottom === undefined
  ) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        transform: `translate3d(${left + outlineWidth}px, ${top + outlineWidth}px, 0)`,
        width: Math.max(right - left, 0) - outlineWidth * 2,
        height: Math.max(bottom - top, 0) - outlineWidth * 2,
        outline: `${outlineWidth}px solid var(--color-tertiary-400)`,
        willChange: "transform, width, height",
      }}
    ></div>
  );
}
